import React, { useState } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { Layout } from './components/Layout';
import Dashboard from './components/Dashboard';
import ClientsPage from './components/clients/ClientsPage';
import ScopesPage from './components/scopes/ScopesPage';
import Settings from './components/Settings';
import LoginPage from './components/auth/LoginPage';
import { isAuthenticated } from './services/auth';

import './custom.css';

export default function App() {
    const [authed, setAuthed] = useState(isAuthenticated());

    if (!authed) {
        return <LoginPage onLogin={() => setAuthed(true)} />;
    }

    return (
        <Layout onLogout={() => setAuthed(false)}>
            <Switch>
                <Route exact path="/" component={Dashboard} />
                <Route path="/clients" component={ClientsPage} />
                <Route path="/scopes" component={ScopesPage} />
                <Route path="/settings" component={Settings} />
                <Redirect to="/" />
            </Switch>
        </Layout>
    );
}